import { useState } from 'react';
import { showInfoToast } from 'src/Utils/toastHelper';
var NO_BUDGET_REQUESTS_MESSAGE = 'No hay solicitudes de presupuesto en este ticket. Crea una solicitud para poder autorizar un pago.';
var ALL_AUTHORIZED_MESSAGE = 'Todas las solicitudes de presupuesto de este ticket ya tienen una autorización de pago.';
export var useInternalConversationActions = function (_a) {
    var budgetRequestsCount = _a.budgetRequestsCount, pendingBudgetRequestsCount = _a.pendingBudgetRequestsCount, onActionSelect = _a.onActionSelect;
    var _b = useState(null), openModal = _b[0], setOpenModal = _b[1];
    var handleActionSelect = function (action) {
        if (action === 'authorize_payment' && pendingBudgetRequestsCount === 0) {
            if (budgetRequestsCount === 0) {
                showInfoToast(NO_BUDGET_REQUESTS_MESSAGE);
            }
            else {
                showInfoToast(ALL_AUTHORIZED_MESSAGE);
            }
            return;
        }
        setOpenModal(action);
        onActionSelect === null || onActionSelect === void 0 ? void 0 : onActionSelect(action);
    };
    var closeModal = function () { return setOpenModal(null); };
    var isProviderModalOpen = openModal === 'create_claim' || openModal === 'request_budget';
    var providerModalType = openModal === 'create_claim' ? 'claim' : 'budget_request';
    return {
        openModal: openModal,
        handleActionSelect: handleActionSelect,
        closeModal: closeModal,
        isProviderModalOpen: isProviderModalOpen,
        providerModalType: providerModalType,
    };
};
